import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { OtpInputInline } from '@root/shared/ui-kit/otp-input'

import type { MfaSetupModel } from '../../atoms/reatom-setup-mfa'
import type { ClassNameProps } from '@root/shared/react'

type SetupOtpConfirmProps = {
  model: MfaSetupModel
  onClose: () => void
} & ClassNameProps

export const SetupOtpConfirm: React.FC<SetupOtpConfirmProps> = ({
  className,
  model,
  onClose,
}) => {
  const [value, setValue] = useState<string | undefined>(undefined)
  const [error, setError] = useState<boolean>(false)
  const [confirmOtpState] = useAtom(model.confirmOtp)
  const confirmOtp = useAction(model.confirmOtp.execute)

  useEffect(() => {
    if (value?.length === 6) {
      confirmOtp({ code: value })
    }
  }, [value, confirmOtp])

  useEffect(() => {
    if (AsyncStateN.isSuccess(confirmOtpState)) {
      onClose()
    }
    if (AsyncStateN.isError(confirmOtpState)) {
      setError(true)
      setTimeout(() => setError(false), 1000)
    }
  }, [confirmOtpState, onClose])

  return (
    <Root className={className}>
      <OtpInputInline
        value={value}
        onChange={setValue}
        disabled={confirmOtpState.loading}
        hasError={error}
      />
    </Root>
  )
}

const Root = styled.div``
